import { ITheme, mediaQuery } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

import { IToolTipProps } from './commonTypes';

const tooltipStyles = createUseStyles<string, { tooltipProps: IToolTipProps }>(
  ({ breakpoints }: ITheme) => ({
    tooltip: {
      height: ({ tooltipProps }) => (tooltipProps != null ? `${tooltipProps.height}px` : 'auto'),
      width: ({ tooltipProps }) =>
        tooltipProps != null ? `min(${tooltipProps.width}px,calc(100vw - 48px))` : 'auto',

      whiteSpace: 'pre-wrap',
      top: ({ tooltipProps }) => (tooltipProps != null ? tooltipProps.top : 'auto'),
      left: ({ tooltipProps }) => (tooltipProps != null ? tooltipProps.left : 'auto'),
      [mediaQuery(breakpoints.tablet)]: {
        top: ({ tooltipProps }) =>
          tooltipProps?.tabletBreakpoints?.top ?? tooltipProps?.top ?? 'auto',
      },
      [mediaQuery(breakpoints.mobile)]: {
        left: ({ tooltipProps }) =>
          tooltipProps?.mobileBreakpoints?.left ?? tooltipProps?.left ?? 'auto',
      },
      [mediaQuery(462)]: {
        left: ({ tooltipProps }) =>
          tooltipProps?.otherBreakpoints?.breakpoint462?.left ??
          tooltipProps?.mobileBreakpoints.left ??
          'auto',
        top: ({ tooltipProps }) =>
          tooltipProps?.otherBreakpoints?.breakpoint462?.top ?? tooltipProps?.top ?? 'auto',
      },
    },
    tooltipArrow: {
      '& > div': {
        width: ({ tooltipProps }) => tooltipProps?.arrowWidth ?? 'auto',

        marginLeft: ({ tooltipProps }) => tooltipProps?.arrowMarginLeft ?? 'auto',
      },
      [mediaQuery(breakpoints.mobile)]: {
        '& > div': {
          marginLeft: ({ tooltipProps }) =>
            tooltipProps?.mobileBreakpoints?.arrowMarginLeft ??
            tooltipProps?.arrowMarginLeft ??
            'auto',
        },
      },
      [mediaQuery(462)]: {
        '& > div': {
          marginLeft: ({ tooltipProps }) =>
            tooltipProps?.otherBreakpoints?.breakpoint462?.arrowMarginLeft ??
            tooltipProps?.mobileBreakpoints.arrowMarginLeft ??
            'auto',
        },
      },
      [mediaQuery(427)]: {
        '& > div': {
          marginLeft: ({ tooltipProps }) =>
            tooltipProps?.otherBreakpoints?.breakpoint427?.arrowMarginLeft ??
            tooltipProps?.mobileBreakpoints.arrowMarginLeft ??
            'auto',
        },
      },
      [mediaQuery(388)]: {
        '& > div': {
          marginLeft: ({ tooltipProps }) =>
            tooltipProps?.otherBreakpoints?.breakpoint388?.arrowMarginLeft ??
            tooltipProps?.mobileBreakpoints.arrowMarginLeft ??
            'auto',
        },
      },
    },
  }),
  { name: 'generic-input' },
);
export default tooltipStyles;
